import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { rootContainer, TYPE } from "../container/root";
import { IMerchantOnboarding, IMerchantOnboardingSettings } from "../../pages/onboarding/onboarding-types";
import { IReturnGuardWarning } from "../../components/return-guard-warning-component/return-guard-warning-store";

interface IMerchantOnboardingResponse {
    onboarding: IMerchantOnboarding | null,
    settings: IMerchantOnboardingSettings,
}
interface IMerchantOnboardingCompletedResponse {

    /**TODO: Currently the report field is not in use, the type should be adjusted when it will */
    report: any
    onboarding: IMerchantOnboarding | null,
}

@injectable()
class OnboardingService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getOnboardingData(): Promise<IMerchantOnboardingResponse> {
        const res = await this.httpService.get<IApiResponse<IMerchantOnboardingResponse>>(`/rms-api/onboarding`);
        return res.payload;
    }

    async saveOnboardingData(data: IMerchantOnboarding): Promise<IMerchantOnboarding> {
        const res = await this.httpService.put<IApiResponse<IMerchantOnboarding>>(`/rms-api/onboarding`, data);
        return res.payload;
    }

    async runProcessor(data: IMerchantOnboarding): Promise<IMerchantOnboardingCompletedResponse> {
        const res = await this.httpService.put<IApiResponse<any>>(`/rms-api/onboarding/complete`, data);
        return res.payload;
    }

    async getReturnGuardWarning(): Promise<IReturnGuardWarning> {
        const res = await this.httpService.get<IApiResponse<IReturnGuardWarning>>(`/rms-api/onboarding/return-guard-warning`);
        return res.payload;
    }

    
}

export default OnboardingService;